const scrollToHeroEmbed = () => {
  window.location.href = '/book-demo'
}

export default scrollToHeroEmbed
